export const FB_ID_COOKIE = 'fbIdentifier';
export const GUEST_TOKEN_COOKIE = 'X-PetPlateGuestToken';
export const AUTH_HEADER_COOKIE = 'X-PetPlate-Authorization';
export const SHOPIFY_CART_COOKIE = 'X-PetPlate-ShopifyCartId';
